import { getOrgEditPermission } from 'types'

/** Org-scoped edit permission used to hide features from the US Navy tenant. */
export const US_NAVY_ORG_PERMISSION = getOrgEditPermission('us-navy-69a72a')
